import { EntReservoir } from "../../../../models/reservoir";
import { ResponseDataTest } from "../../../../models/responseDataTest";
import { EntReservoirHistoryFilter } from "../../../../models/filters/reservoirHistoryFilter";
import { agroApi } from "../../../../redux/api/api";
import { Paths } from "../../../../paths";

export const reservoirHistoryApi = agroApi.injectEndpoints({
  endpoints: (builder) => ({
    getByIdReservoir: builder.query<ResponseDataTest<EntReservoir>, EntReservoirHistoryFilter>({
      query: (filter) => ({
        url: '/reservoir-history/by-reservoir-id',
        // url: `${Paths.reservoir.reservoirshistory}/by-reservoir-id`,
        method: 'POST',
        body: {
          reservoirId: filter.reservoirId,
          dateForDayFrom: filter.dateForDayFrom,
          dateForDayTo: filter.dateForDayTo,
          page: filter.page,
          size: filter.size,
          deleted: filter.deleted,
        },
      }),
    }),
  }),
});

export const { useGetByIdReservoirQuery } = reservoirHistoryApi;
